import { AxiosInstance } from 'axios';
import http from '../../../../http';

export interface CompleteCheckoutProps {
  productId: string;
  requestBody: CheckoutPaymentRequestBody;
}

export interface CheckoutPaymentRequestBody {
  student: {
    firstName: string;
    lastName: string;
    email: string;
  };
  paymentData: {
    card?: {
      token: string;
      type: string;
      last4Digits: string;
      cardExpiry: string;
    };
    billingAddress: {
      country: string;
      postalCode: string;
    };
  };
  selectedPaymentPlanId: string | null;
}

export interface CompletionDetails {
  price: number;
  studentFirstName: string;
  studentLastName: string;
  checkoutSessionId: string;
  email: string;
  productName: string;
  redirectPage: string | null;
}

function completeCheckoutCtor(http: AxiosInstance) {
  return async function completeCheckout({
    productId,
    requestBody,
  }: CompleteCheckoutProps): Promise<CompletionDetails> {
    const { data } = await http.post(`/checkout-full/${productId}/complete`, requestBody);
    return data;
  };
}

export default completeCheckoutCtor(http);
